import { useState, useEffect, useContext } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../contexts";

import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import HealingOutlinedIcon from "@material-ui/icons/HealingOutlined";
import { FaClinicMedical, FaChartLine } from "react-icons/fa";
import { BsShieldFillCheck } from "react-icons/bs";

import { Grid } from "@material-ui/core";

import "./summary.css";
import OverViewCard from "./summaryCard/AnalyticsOverViewCard";
import CoreEnrollmentCountChart from "./summaryChart/CoreEnrollmentCountChart";
import SummaryMap from "./summaryMap/SummaryMap";

const Summary = () => {
	const { setDashboardHeader } = useContext(UIContext);
	const [summaryAnalyticsData, setSummaryAnalyticsData] = useState({
		active_healthcare_plan_count: 10224,
		VEB_annual_premium: 2034556,
		active_clinic_card_count: 45678,
		YOE_enrollment_count: 6745689,
		core_active_enrollment: [],
		VEB_actve_enrollment: []
	});
	const [enrollCountData, setEnrollCountData] = useState([
		{
			plan_name: "Health Plan",
			enroll_count: 14000
		},
		{
			plan_name: "CC",
			enroll_count: 5000
		},

		{
			plan_name: "GSTD",
			enroll_count: 8100
		},
		{
			plan_name: "GSTD(Class 1)",
			enroll_count: 12000
		},
		{
			plan_name: "GSTD(Class 2)",
			enroll_count: 19000
		},
		{
			plan_name: "HOO",
			enroll_count: 3200
		},
		{
			plan_name: "KSOP",
			enroll_count: 14530
		},
		{
			plan_name: "GLI",
			enroll_count: 17000
		},
		{
			plan_name: "CCEF",
			enroll_count: 31100
		}
	]);
	const [cardData, setCardData] = useState([
		{
			icon: () => (
				<div className="premium-amount-icon-container icon-button-container">
					{/* <AiOutlineDollar /> */}
					<MonetizationOnOutlinedIcon />
				</div>
			),
			title: "VEB Annual Premium",
			amount: "$986,829.98",
			className: "total-premium-container"
		},
		{
			icon: () => (
				<div className="health-plan-icon-container icon-button-container">
					{" "}
					<BsShieldFillCheck />
				</div>
			),
			title: "Active Health Plans",
			amount: "10,234",
			className: "health-plan-analytics-container"
		},
		{
			icon: () => (
				<div className="clinic-card-icon-container icon-button-container">
					<FaClinicMedical />
				</div>
			),
			title: "Active Clinic Cards",
			amount: "20,346",
			className: "clinic-card-analytics-container"
		},
		{
			icon: () => (
				<div className="yoa-analytics-icon-container icon-button-container">
					<FaChartLine />
				</div>
			),
			title: "YOE Enrollment",
			amount: "35,567",
			className: "yoe-analytics-container"
		}
	]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.summary);
	}, [setDashboardHeader]);

	return (
		<div className="summary-container">
			<div className="analytics-overview-container">
				<div className="analytics-overview-header overview-header">Analytics Overview</div>

				<div className="margin-top-action-button" />
				<OverViewCard cardDetails={cardData} />
			</div>
			<div className="core-plan-overview-container margin-top-action-button">
				<CoreEnrollmentCountChart enrollCountData={enrollCountData} />
			</div>
			<div className="map-overview-container margin-top-action-button">
				<Grid container>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<SummaryMap />
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default Summary;
